


import { TextField, Box, Typography, Button } from '@mui/material';

// const RatedConsumptionFilter = ({ minConsumption, maxConsumption, setMinConsumption, setMaxConsumption, onApply }) => {
    const RatedConsumptionFilter = ({ minConsumption, maxConsumption, setMinConsumption, setMaxConsumption,errors }) => {
      const handleChange = (type) => (e) => {
        const value = e.target.value;
        // Allow only numbers and decimal points
        if (/^[0-9]*\.?[0-9]*$/.test(value)) {
          type === 'min' 
            ? setMinConsumption(value)
            : setMaxConsumption(value);
        }
      };
  return (
    <Box sx={{ m: '5%', mt: 0 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', marginBottom: '30px' }}>
        Rated Consumption
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
        <TextField
          label="Min"
          variant="outlined"
          size="small"
          value={minConsumption}
          // onChange={(e) => setMinConsumption(e.target.value)}
          onChange={handleChange('min')}
          sx={{ width: '135px' }}
        />
        <Typography variant="body1">to</Typography>
        <TextField
          label="Max"
          variant="outlined"
          size="small"
          value={maxConsumption}
          // onChange={(e) => setMaxConsumption(e.target.value)}
          onChange={handleChange('max')}
          sx={{ width: '135px' }}
        />
      </Box>
      {errors && (
            <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
              {errors}
            </Typography>
          )}
    </Box>
   
  );
};

export default RatedConsumptionFilter;